import { Box } from '@src/atoms/Box';
import { Dialog } from '@src/atoms/Dialog';
import { Text } from '@src/atoms/Text';
import React, { FC, ReactNode } from 'react';

export interface IDialogWrapperProps {
  title: ReactNode;
  description: ReactNode;
  dialogId: string;
}

/**
 * Компонент для построение хедера у диалога с лего
 *
 * Включают заголовок диалога и его описание и отступы в соответствии с макетами
 * @link макеты - https://www.figma.com/design/7tSylW4PyQ3ZacyQYja5uK/Web-System?node-id=5831-12638&node-type=frame&t=xe2N4v6hQyaWdnTe-0
 */
export const LegoElementDialogHeader: FC<IDialogWrapperProps> = ({ dialogId, description, title }) => {
  return (
    <>
      <Dialog.Header>
        <Box fullWidth gap={8} column paddingBottom={{ DESKTOP: 16, MOBILE: 8 }}>
          {typeof title === 'string' ? (
            <Text id={`${dialogId}Title`} size="h3">
              {title}
            </Text>
          ) : (
            title
          )}

          {description}
        </Box>
      </Dialog.Header>
    </>
  );
};
